import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiper = new Swiper(element.querySelector(".swiper-articles"), {
        modules: [Navigation],
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 10,
        navigation: {
            nextEl: element.querySelector(".swiper-button_next"),
            prevEl: element.querySelector(".swiper-button_prev"),
        },
        breakpoints: {
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            460: {
                spaceBetween: 20,
                slidesPerView: 2,
            },
        }
    });
}
